<template>
  <button
    :aria-label="ariaLabel"
    :class="buttonPlayClasses"
    @click="onPlay"
    @keydown="onPlaySpace"
    @keyup="onCancelPlay"
    tabindex="0"
  >
    <Icon
      name="audio"
      :size="size"
      :color="colorIcon"
      focusable="false"
      class="icon-position"
    />
  </button>
</template>

<script>
import { Icon } from '../../Icon';

export default {
  name: 'TextToSpeechButtonPlay',
  inject: ['tts'],
  components: { Icon },
  computed: {
    buttonPlayClasses() {
      const btnPlayAudioClass = {
        'button--play-audio': true,
      };

      btnPlayAudioClass[`bg-${this.bgColor}`] = !!this.bgColor;
      btnPlayAudioClass[`bg-${this.bgColorHover}-hover`] = !!this.bgColorHover;
      btnPlayAudioClass[`text-${this.textColor}`] = !!this.textColor;
      btnPlayAudioClass[`outline-${this.btnOutlineColor}`] =
        !!this.btnOutlineColor;

      return {
        ...btnPlayAudioClass,
      };
    },
  },
  props: {
    textColor: {
      type: String,
      required: false,
      default: null,
    },
    bgColor: {
      type: String,
      required: false,
    },
    bgColorHover: {
      type: String,
      required: false,
    },
    colorIcon: {
      type: String,
      required: false,
    },
    size: {
      type: [String, Number],
      default: '1em',
    },
    btnOutlineColor: {
      type: String,
      required: false,
    },
    ariaLabel: {
      type: String,
      default: 'Speaker',
    },
  },
  methods: {
    onPlaySpace(e) {
      e.stopPropagation();
      if (e.keyCode === 32) {
        e.preventDefault();
        this.handlePlay();
      }
    },
    onPlay(e) {
      e.stopPropagation();
      if (!this.tts.textToSpeech.View.isStopped()) {
        return this.tts.textToSpeech.View.stop();
      }
      this.handlePlay();
    },
    handlePlay() {
      if (this.tts.textToSpeech && this.tts.textToSpeech.View) {
        this.tts.textToSpeech.View.stop();
        this.tts.$emit('onPlay');
      }
    },
    onCancelPlay(e) {
      if (e.keyCode === 32) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/btn_play_audio.styl';

.icon-position
  position: relative
  right: 1.2px
  bottom: 1.2px
</style>
